/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSessionModel } from '../../models/patient-session-model';

export interface SavePatientSession$Params {
  confirmSessionSwitch?: boolean;
      body?: PatientSessionModel
}

export function SavePatientSession(http: HttpClient, rootUrl: string, params?: SavePatientSession$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientSessionModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientSession.PATH, 'post');
  if (params) {
    rb.query('confirmSessionSwitch', params.confirmSessionSwitch, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientSessionModel>;
    })
  );
}

SavePatientSession.PATH = '/api/Staff/SavePatientSession';
